import {
  Element,
  InstallSpec,
  ItemComponent,
  Option,
} from "@p0security/shared/install/types";
import { pathSegmentIdValidator } from "@p0security/shared/install/validators";

export const CustomComponents = InstallSpec({
  base: ItemComponent({
    label: "Custom",
    type: "generated",
    hidden: true,
    maturity: "ga",
    schema: {},
  }),
  "iam-write": ItemComponent({
    label: "IAM management",
    description:
      "Allows P0 to manage access to your custom resource for your users.",
    type: "string",
    maturity: "ga",
    schema: {
      name: Element({
        label: "Application name",
        description: "A user friendly name of the custom resource application",
        type: "string",
      }),
      service: Element({
        label: "Service provider",
        description:
          "The service provider hosting the external function to call",
        type: "select",
        default: "aws",
        options: {
          aws: Option({
            maturity: "ga" as const,
            key: "aws",
            label: "AWS",
            schema: {
              lambda: Element({
                label: "Function caller",
                type: "dynamic",
              }),
            },
          }),
          // ENG-5381: Add Azure option
          azure: Option({
            maturity: "preview" as const,
            key: "azure",
            label: "Azure",
            schema: {
              service: Element({
                label: "Function caller",
                type: "dynamic",
              }),
            },
          }),
          gcp: Option({
            maturity: "ga" as const,
            key: "gcp",
            label: "GCP",
            schema: {
              cloudRun: Element({
                label: "Function caller",
                type: "dynamic",
              }),
            },
          }),
        },
      }),
    },
  }),
  "iam-assessment": ItemComponent({
    label: "IAM assessment",
    description: "Allows P0 to assess custom resources and identities.",
    type: "string",
    maturity: "ga",
    // The ID is the inventory scope, which is a route param and a document ID
    validator: pathSegmentIdValidator,
    schema: {
      name: Element({
        label: "System name",
        description: "A user friendly name for the custom system to assess",
        type: "string",
      }),
    },
  }),
});
